import api from "../../api/index";

const fetchgroups = `${process.env.VUE_APP_BASE_URI}/groups`;
const singlegroup = `${process.env.VUE_APP_BASE_URI}/groups`;
const addGroup = `${process.env.VUE_APP_BASE_URI}/groups`;
const fetchgrouptempstats = `${process.env.VUE_APP_BASE_URI}/group/temperature`;
const fetchgrouphumistats = `${process.env.VUE_APP_BASE_URI}/group/humidity`;
const fetchgrouplocations = `${process.env.VUE_APP_BASE_URI}/group/location`;
const groupdevice = `${process.env.VUE_APP_BASE_URI}/group/device`;
const groupuser = `${process.env.VUE_APP_BASE_URI}/group/user`;
const grouprecords = `${process.env.VUE_APP_BASE_URI}/grouprecords`;
const grouprecord = `${process.env.VUE_APP_BASE_URI}/gammagrouprecord`;
const endgrouprecord = `${process.env.VUE_APP_BASE_URI}/grouprecord/end`;
const startgrouprecord = `${process.env.VUE_APP_BASE_URI}/grouprecord/start`;
const fetchgroupdevicestats = `${process.env.VUE_APP_BASE_URI}/group/devices`;
const recordstats = `${process.env.VUE_APP_BASE_URI}/gammarecordstats`;
const recordlocations = `${process.env.VUE_APP_BASE_URI}/recordlocations`;
const singlegroupoverview = `${process.env.VUE_APP_BASE_URI}/group/overview`;
const singlegroupusers = `${process.env.VUE_APP_BASE_URI}/group/users`;
const singlegroupdevices = `${process.env.VUE_APP_BASE_URI}/group/devices`;
const singlegroupstats = `${process.env.VUE_APP_BASE_URI}/group/stats`;
const groupStats = `${process.env.VUE_APP_BASE_URI}/groupStats`;

const getDefaultState = () => {
  return {
    status: "",
    groups: [],
    singlegroup: { overview: {} },
    grouptempstats: [],
    grouphumistats: [],
    grouplocations: [],
    grouprecords: [],
    groupdevicestats: {},
    singlerecord: [],
    recordstats: [],
    recordlocations: [],
    singlegroupoverview: [],
    singlegroupusers: [],
    singlegroupdevices: [],
    singlegroupstats: [],
    groupStats: [],
    meta: {},
  };
};

const state = getDefaultState();

const getters = {
  groups: (state) => state.groups,
  singlegroup: (state) => state.singlegroup,
  singlegroupId: (state) => state.singlegroup,
  grouptempstats: (state) => state.grouptempstats,
  grouphumistats: (state) => state.grouphumistats,
  groupdevicestats: (state) => state.groupdevicestats,
  grouplocations: (state) => state.grouplocations,
  grouprecords: (state) => state.grouprecords,
  singlerecord: (state) => state.singlerecord,
  recordstats: (state) => state.recordstats,
  recordlocations: (state) => state.recordlocations,
  singlegroupoverview: (state) => state.singlegroupoverview,
  singlegroupusers: (state) => state.singlegroupusers,
  singlegroupdevices: (state) => state.singlegroupdevices,
  singlegroupstats: (state) => state.singlegroupstats,
  groupStats: (state) => state.groupStats,
  groupsMeta: (state) => state.meta,
};
const actions = {
  async fetchGroups({ commit }, params) {
    commit("fetchgroups_request");
    const res = await api.get(fetchgroups, { params });
    if (res.data.success) {
      commit("fetchgroups_success", res.data.payload);
    }
    return res;
  },

  async fetchGroupTempStats({ commit }, { group_id }) {
    commit("fetchgrouptempstats_request");
    const res = await api.get(`${fetchgrouptempstats}/${group_id}`);
    if (res.data.success) {
      commit("fetchgrouptempstats_success", res.data.overview.stats);
    }
    return res;
  },
  async fetchCustomGroupTempStats({ commit }, { group_id, period }) {
    commit("fetchcustomgrouptempstats_request");
    const res = await api.post(`${fetchgrouptempstats}/${group_id}`, period);
    if (res.data.success) {
      commit("fetchcustomgrouptempstats_success", res.data.overview.stats);
    }
    return res;
  },
  async fetchGroupHumiStats({ commit }, { group_id }) {
    commit("fetchgrouphumistats_request");
    const res = await api.get(`${fetchgrouphumistats}/${group_id}`);
    if (res.data.success) {
      commit("fetchgrouphumistats_success", res.data.overview.stats);
    }
    return res;
  },
  async fetchGroupDeviceStats({ commit }, { group_id, type, period }) {
    commit("fetchgroupdevicestats_request");
    const res = await api.post(
      `${fetchgroupdevicestats}/${group_id}/${type}`,
      period,
    );
    if (res.data.success) {
      commit("fetchgroupdevicestats_success", res.data);
    }
    return res;
  },
  async fetchCustomGroupHumiStats({ commit }, { group_id, period }) {
    commit("fetchcustomgrouphumistats_request");
    const res = await api.post(`${fetchgrouphumistats}/${group_id}`, period);
    if (res.data.success) {
      commit("fetchcustomgrouphumistats_success", res.data.overview.stats);
    }
    return res;
  },
  async fetchGroupLocations({ commit }, { group_id }) {
    commit("fetchgrouplocations_request");
    const res = await api.get(`${fetchgroups}/${group_id}/devices`);
    if (res.data.success) {
      commit("fetchgrouplocations_success", res.data.payload);
    }
    return res;
  },

  async fetchGroupRecords({ commit }, { id }) {
    commit("fetchgrouprecords_request");
    const res = await api.get(`${grouprecords}/${id}`);
    if (res.data.success) {
      commit("fetchgrouprecords_success", res.data.records);
    }
    return res;
  },

  async fetchSingleGroupRecord({ commit }, { id, recordId }) {
    commit("fetchsinglegrouprecord_request");
    const res = await api.get(`${grouprecord}/${id}/${recordId}`);
    if (res.data.success) {
      commit("fetchsinglegrouprecord_success", res.data);
    }
    return res;
  },

  async fetchSingleGroupRecordLocations({ commit }, { id, recordId }) {
    commit("fetchsinglegrouprecordlocations_request");
    const res = await api.get(`${recordlocations}/${id}/${recordId}`);
    if (res.data.success) {
      commit("fetchsinglegrouprecordlocations_success", res.data.locations);
    }
    return res;
  },

  async fetchSingleGroupRecordCustom({ commit }, { id, recordId, type }) {
    commit("fetchsinglegrouprecordcustom_request");
    const res = await api.get(`${recordstats}/${id}/${recordId}/${type}`);
    if (res.data.success) {
      commit("fetchsinglegrouprecordcustom_success", res.data.payload);
    }
    return res;
  },

  async fetchSingleGroup({ commit }, { id }) {
    commit("fetchsinglegroup_request");
    const res = await api.get(`${singlegroup}/${id}`);
    if (res.data.success) {
      commit("fetchsinglegroup_success", res.data.payload);
    }
    return res;
  },

  async addGroup({ commit }, newgroup) {
    commit("addgroup_request");
    const res = await api.post(addGroup, newgroup);
    if (res.data.success) {
      commit("addgroup_success", res.data);
    }
    return res;
  },

  async createGroupRecord({ commit }, { id, newrecord }) {
    commit("creategrouprecord_request");
    const res = await api.post(`${grouprecords}/${id}`, newrecord);
    if (res.data.success) {
      commit("creategrouprecord_success", res.data);
    }
    return res;
  },

  // async endGroupRecord({ commit }, { id, recordId, endtime }) {
  //   commit("endgrouprecord_request");
  //   const res = await api.put(`${endgrouprecord}/${id}/${recordId}`, endtime);
  //   if (res.data.success) {
  //     commit("endgrouprecord_success", res.data);
  //   }
  //   return res;
  // },

  async endGroupRecord({ commit }, { id, recordId }) {
    commit("endgrouprecord_request");
    const res = await api.put(`${endgrouprecord}/${id}/${recordId}`);
    if (res.data.success) {
      commit("endgrouprecord_success", res.data);
    }
    return res;
  },

  async startGroupRecord({ commit }, { id, recordId }) {
    commit("startgrouprecord_request");
    const res = await api.put(`${startgrouprecord}/${id}/${recordId}`);
    if (res.data.success) {
      commit("startgrouprecord_success", res.data);
    }
    return res;
  },

  async updateGroup({ commit }, { id, updatedgroup }) {
    commit("updategroup_request");
    const res = await api.patch(`${singlegroup}/${id}`, updatedgroup);
    if (res.data.success) {
      commit("updategroup_success", res.data.payload);
    }
    return res;
  },

  async addGroupDevices({ commit }, { devices, id }) {
    commit("addgroupdevices_request");
    const res = await api.patch(`${singlegroup}/${id}/devices`, devices);
    if (res.data.success) {
      commit("addgroupdevices_success", res.data.payload);
    }
    return res;
  },

  async addGroupUsers({ commit }, { users, id }) {
    commit("addgroupusers_request");
    const res = await api.patch(`${singlegroup}/${id}/users`, users);
    if (res.data.success) {
      commit("addgroupusers_success", res.data);
    }
    return res;
  },

  async deleteGroupDevice({ commit }, { id, device }) {
    commit("deletegroupdevice_request");
    const res = await api.delete(`${singlegroup}/${id}/devices`, {
      data: {
        devices: [device],
      },
    });
    if (res.data.success) {
      commit("deletegroupdevice_success", res.data.payload);
    }
    return res;
  },

  async deleteGroupRecord({ commit }, { id, recordId }) {
    commit("deletegrouprecord_request");
    const res = await api.delete(`${grouprecord}/${id}/${recordId}`);
    if (res.data.success) {
      commit("deletegrouprecord_success", res.data);
    }
    return res;
  },

  async deleteGroupUser({ commit }, { id, user }) {
    commit("deletegroupuser_request");
    const res = await api.delete(`${singlegroup}/${id}/users`, {
      data: {
        users: [user],
      },
    });
    if (res.data.success) {
      commit("deletegroupuser_success", res.data.payload);
    }
    return res;
  },

  async deleteGroup({ commit }, { id }) {
    commit("deletegroup_request");
    const res = await api.delete(`${singlegroup}/${id}`);
    if (res.data.success) {
      commit("deletegroup_success", res.data);
    }
    return res;
  },
  async fetchSingleGroupOverview({ commit }, { id }) {
    commit("fetchsinglegroupoverview_request");
    const res = await api.get(`${singlegroup}/${id}/overview`);
    if (res.data.success) {
      commit("fetchsinglegroupoverview_success", res.data.payload);
    }
    return res;
  },
  async fetchSingleGroupUsers({ commit }, { id }) {
    commit("fetchsinglegroupusers_request");
    const res = await api.get(`${singlegroup}/${id}/users`);
    if (res.data.success) {
      commit("fetchsinglegroupusers_success", res.data.payload);
    }
    return res;
  },
  async fetchSingleGroupDevices({ commit }, { id }) {
    commit("fetchsinglegroupdevices_request");
    const res = await api.get(`${singlegroup}/${id}/devices`);
    if (res.data.success) {
      commit("fetchsinglegroupdevices_success", res.data.payload);
    }
    return res;
  },
  async fetchSingleGroupStats({ commit }, { id }) {
    commit("fetchsinglegroupstats_request");
    const res = await api.get(`${singlegroup}/${id}/chart`);
    if (res.data.success) {
      commit("fetchsinglegroupstats_success", res.data.payload);
    }
    return res;
  },
  async getGroupStats({ commit }, { id }) {
    commit("groupStats_request");
    const res = await api.get(`${groupStats}/${id}`);
    if (res.data.success) {
      // const statsDevice = res.data.data.allStats.map((stats) => ({
      //   stats: stats,
      // }));
      commit("groupStats_success", res.data.data.allStats);
    }
    return res;
  },

  async resetGroupsState({ commit }) {
    await commit("resetgroupsstate_success");
  },

  async downloadGroupReport({ commit }, downloadedGroupReport) {
    const res = await api.post(
      `${fetchgroups}/download-report`,
      downloadedGroupReport,
    );
    if (res.data.success) {
      commit("downloadGroupReport_success");
    }
    return res;
  },

  async updateSelectedId({ commit }, ids) {
    commit("setSelectedId", ids);
  },
};

const mutations = {
  fetchgroups_request: (state) => (state.status = "loading"),
  fetchgroups_success: (state, groups) => {
    state.status = "success";
    state.groups = groups.data;
    state.meta = groups.meta;
  },
  fetchgrouptempstats_request: (state) => (state.status = "loading"),
  fetchgrouptempstats_success: (state, data) => {
    state.status = "success";
    state.grouptempstats = data;
  },
  fetchcustomgrouptempstats_request: (state) => (state.status = "loading"),
  fetchcustomgrouptempstats_success: (state, data) => {
    state.status = "success";
    state.grouptempstats = data;
  },
  fetchgrouphumistats_request: (state) => (state.status = "loading"),
  fetchgrouphumistats_success: (state, data) => {
    state.status = "success";
    state.grouphumistats = data;
  },
  fetchcustomgrouphumistats_request: (state) => (state.status = "loading"),
  fetchcustomgrouphumistats_success: (state, data) => {
    state.status = "success";
    state.grouphumistats = data;
  },
  fetchgroupdevicestats_request: (state) => (state.status = "loading"),
  fetchgroupdevicestats_success: (state, data) => {
    state.status = "success";
    state.groupdevicestats = data;
  },
  fetchgrouplocations_request: (state) => (state.status = "loading"),
  fetchgrouplocations_success: (state, locations) => {
    state.status = "success";
    state.grouplocations = locations.devices;
  },
  fetchgrouprecords_request: (state) => (state.status = "loading"),
  fetchgrouprecords_success: (state, records) => {
    state.status = "success";
    state.grouprecords = records;
  },
  fetchsinglegroup_request: (state) => (state.status = "loading"),
  fetchsinglegroup_success: (state, singlegroup) => {
    state.status = "success";
    state.singlegroup = { ...state.singlegroup, group: singlegroup };
  },
  fetchsinglegrouprecord_request: (state) => (state.status = "loading"),
  fetchsinglegrouprecord_success: (state, singlerecord) => {
    state.status = "success";
    state.singlerecord = singlerecord;
  },
  fetchsinglegrouprecordcustom_request: (state) => (state.status = "loading"),
  fetchsinglegrouprecordcustom_success: (state, singlerecord) => {
    state.status = "success";
    state.singlerecord = singlerecord;
  },
  fetchsinglegrouprecordlocations_request: (state) =>
    (state.status = "loading"),
  fetchsinglegrouprecordlocations_success: (state, recordlocations) => {
    state.status = "success";
    state.recordlocations = recordlocations;
  },
  addgroup_request: (state) => (state.status = "loading"),
  addgroup_success: (state) => (state.status = "success"),
  creategrouprecord_request: (state) => (state.status = "loading"),
  creategrouprecord_success: (state) => (state.status = "success"),
  updategroup_request: (state) => (state.status = "loading"),
  updategroup_success: (state) => (state.status = "success"),
  addgroupdevices_request: (state) => (state.status = "loading"),
  addgroupdevices_success: (state) => (state.status = "success"),
  addgroupusers_request: (state) => (state.status = "loading"),
  addgroupusers_success: (state) => (state.status = "success"),
  deletegroupdevice_request: (state) => (state.status = "loading"),
  deletegroupdevice_success: (state) => (state.status = "success"),
  deletegroupuser_request: (state) => (state.status = "loading"),
  deletegroupuser_success: (state) => (state.status = "success"),
  deletegrouprecord_request: (state) => (state.status = "loading"),
  deletegrouprecord_success: (state) => (state.status = "success"),
  deletegroup_request: (state) => (state.status = "loading"),
  deletegroup_success: (state) => (state.status = "success"),
  startgrouprecord_request: (state) => (state.status = "loading"),
  startgrouprecord_success: (state) => (state.status = "success"),
  endgrouprecord_request: (state) => (state.status = "loading"),
  endgrouprecord_success: (state) => (state.status = "success"),
  fetchsinglegroupoverview_request: (state) => (state.status = "loading"),
  fetchsinglegroupoverview_success: (state, singlegroup) => {
    state.status = "success";
    state.singlegroupoverview = singlegroup;
    state.singlegroup = {
      ...state.singlegroup,
      overview: singlegroup.overview,
    };
  },
  fetchsinglegroupusers_request: (state) => (state.status = "loading"),
  fetchsinglegroupusers_success: (state, users) => {
    state.status = "success";
    state.singlegroupusers = users.users;
    state.singlegroup = { ...state.singlegroup, users: users.users };
  },
  fetchsinglegroupdevices_request: (state) => (state.status = "loading"),
  fetchsinglegroupdevices_success: (state, devices) => {
    state.status = "success";
    // state.singlegroupdevices = devices.devices;
    state.singlegroup = { ...state.singlegroup, devices: devices.devices };
  },
  fetchsinglegroupstats_request: (state) => (state.status = "loading"),
  fetchsinglegroupstats_success: (state, stats) => {
    state.status = "success";
    state.singlegroupstats = stats;
  },
  groupStats_request: (state) => (state.status = "loading"),
  groupStats_success: (state, stats) => {
    state.status = "success";
    state.groupStats = stats;
  },
  resetgroupsstate_success: (state) => Object.assign(state, getDefaultState()),

  downloadGroupReport_success: (state) => (state.status = "success"),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
